import { GoogleAnalytics, GoogleTagManager } from '@next/third-parties/google';
import appConfig from 'app-config';
const GoogleThirdPartyScripts = () => <>
    {appConfig.gaId && <GoogleAnalytics gaId={appConfig.gaId} />}
    {appConfig.gtmId && <GoogleTagManager gtmId={appConfig.gtmId} />}
  </>;
export default GoogleThirdPartyScripts;